import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMedia } from 'react-use';
import { StyledListViewButton } from './ListViewButton.styles';
import { Icon } from '../../atoms/Icon/Icon';
import { MediaQuery } from '../../../styles/mediaQuery';

export function ListViewButton(): ReactElement {
  const isTablet = useMedia(MediaQuery.Medium);
  return (
    <StyledListViewButton
      aria-label="view list page"
      id="list-view-button"
      href="/route-map-list-view/?clk=RTMAPLIST"
      enforceLink
    >
      {isTablet && (
        <FormattedMessage
          id="map-button-listview"
          description="list view button"
          defaultMessage="View List"
        />
      )}
      <Icon.List />
    </StyledListViewButton>
  );
}
